import { createSlice } from "@reduxjs/toolkit";
import {
  saveGenericName,
  deleteGenericName,
} from "./genericNameThunks";
import { fetchGenericNames, fetchItemUnits } from "../Product_manage/itemManageThunks";

const genericNameSlice = createSlice({
  name: "genericNames",

  initialState: {
    selectedGenericName: null,
    isEditGenericName: false,
    successMessage: null,
  },

  reducers: {

    setSelectedGenericName: (state, action) => {
      state.selectedGenericName = action.payload;
    },

    setIsEditGenericName: (state, action) => {
      state.isEditGenericName = action.payload;
    },

    resetGenericNameStatus: (state) => {
      state.successMessage = null;
    },
  },

  extraReducers: (builder) => {

    builder
      .addCase(
        saveGenericName.fulfilled,
        (state, action) => {
          state.successMessage =
            action.payload.message;
        }
      )
.addCase(fetchItemUnits.fulfilled, (state, action) => {
  state.units = action.payload;
})

.addCase(fetchGenericNames.fulfilled, (state, action) => {
  state.genericNames = action.payload;
})
      .addCase(
        deleteGenericName.fulfilled,
        (state, action) => {
          state.successMessage =
            action.payload.message;
        }
      );
  },
});

export const {
  setSelectedGenericName,
  setIsEditGenericName,
  resetGenericNameStatus,
} = genericNameSlice.actions;

export default genericNameSlice.reducer;